import { TextField } from "@shopify/polaris";
import { FieldRenderProps } from "react-final-form";
import { FC } from "react";

interface SelectedProductsFieldProps extends FieldRenderProps<any> { }

const StockLevelField: FC<SelectedProductsFieldProps> = ({ input, prefix, label, meta, min }) => {
  const { touched, error, submitFailed } = meta;
  const showError = (touched || submitFailed) && error;

  return (
    <TextField
      label={label}
      value={input.value}
      onChange={input.onChange}
      autoComplete="off"
      prefix={prefix}
      type="number"
      min={min}
      error={showError}
      onBlur={() => input.onBlur()}
    />
  );
};

export default StockLevelField;
